module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_tablet_03@2x-c662444b5e0eda57fdffc1140d3a2f86.jpg";